export class TimetableApiService {
  constructor(http, patientApi) {
    this.endpoint = '/timeslot/';
    this.http = http;
    this.patientApi = patientApi;
  }

  async getAll() {
    const response = await this.http.get(this.endpoint);
    const data = response.data;
    return { items: data };
  }

  async getAllByDoctor(uuid, start, end) {
    const params = { start, end };
    const response = await this.http.get(
      `${this.endpoint}by_doctor/${uuid}`,
      params
    );
    return response.data.map(item => {
      const patient = item.patient
        ? { id: item.id, ...this.patientApi.serialize(item.patient) }
        : null;
      return { ...item, patient };
    });
  }

  async getAllByDay(start, end) {
    const params = { start, end };
    const response = await this.http.get(
      `${this.endpoint}by_day/`,
      params
    );
    return response.data.map(item => {
      const patient = item.patient
        ? { id: item.id, ...this.patientApi.serialize(item.patient) }
        : null;
      return { ...item, patient };
    });
  }

  async reserveSlot(uuid, params) {
    const response = await this.http.get(`${this.endpoint}${uuid}/reserve/`, params);
    return response.data;
  }

  async create(slot) {
    await this.http.post(this.endpoint, slot);
  }

  async update(uuid, slot) {
    await this.http.put(this.endpoint + uuid, slot);
    return { status: 200 };
  }

  async remove(uuid) {
    await this.http.delete(this.endpoint + uuid);
    return { status: 200 };
  }
}
